export default __webpack_public_path__ + "static/media/10.3bc4ef89.jpg";